import Vue from 'vue'
import Vuex from 'vuex'
import Request from '@/request/index'
import {
  getRouters
} from '@/utils/menu'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'
export default new Vuex.Store({
  strict: debug,
  state: {
    Authorization: '', // 用户accessToken
    accessToken: '', // 物联网access_token
    userInfo: {}, // 用户信息
    menuList: [], // 菜单
    routersList: [], // 路由
    collapsed: false, // 菜单是否折叠
    breadcrumb: [], // 面包屑
    permission: '', // 权限
    isAdmin: ''
  },
  mutations: {
    setAuthorization (state, val) { // 登录后的accessToken
      state.Authorization = val
      // localStorage.setItem('store', JSON.stringify(state))
      localStorage.setItem('Authorization', val)
    },
    setAccessToken (state, val) { // 物联网的accessToken
      state.accessToken = val
      localStorage.setItem('session_accessToken', val)
      sessionStorage.setItem('session_accessToken', val)
    },
    setUserInfo (state, val) {
      state.userInfo = val
      localStorage.setItem('store', JSON.stringify(state))
      localStorage.setItem('session_userInfo', JSON.stringify(val))
      sessionStorage.setItem('session_userInfo', JSON.stringify(val))
    },
    setMenu (state, val) {
      state.menuList = val
      localStorage.setItem('store', JSON.stringify(state))
      localStorage.setItem('session_menuList', JSON.stringify(val))
      sessionStorage.setItem('session_menuList', JSON.stringify(val))
    },
    setRouters (state, val) {
      state.routersList = val
      localStorage.setItem('store', JSON.stringify(state))
      localStorage.setItem('session_routersList', JSON.stringify(val))
      sessionStorage.setItem('session_routersList', JSON.stringify(val))
    },
    setCollapsed (state, val) {
      state.collapsed = val
      localStorage.setItem('store', JSON.stringify(state))
    },
    setBreadcrumb (state, val) {
      state.breadcrumb = val
      localStorage.setItem('store', JSON.stringify(state))
    },
    setPermission (state, val) {
      state.permission = val
      localStorage.setItem('store', JSON.stringify(state))
    },
    setIsAdmin (state, val) {
      state.isAdmin = val
      localStorage.setItem('store', JSON.stringify(state))
    }

  },
  actions: {
    getAllMenu ({
      commit
    }) {
      return new Promise((resolve, reject) => {
        // let sendData = {
        //   id: JSON.parse(localStorage.getItem('session_userInfo')).userId
        // }
        let successCallback = (resp) => {
          let dataObj = resp.data
          if (dataObj.code === 20000) {
            commit('setMenu', dataObj.data) // 菜单
            commit('setRouters', getRouters(dataObj.data)) // 路由
            resolve(dataObj.data)
          } else {
            this.$message.error(dataObj.data)
            reject(dataObj.data)
          }
        }
        let errorCallBack = (err) => {
          reject(err)
        }
        Request.frontmenu({
          loading: false,
          type: 'get',
          // data: sendData,
          success: successCallback,
          error: errorCallBack
        })
      })
    },
    getAccessToken ({
      commit
    }) {
      let successCallback = (resp) => {
        commit('setAccessToken', resp.data)
      }
      Request.getAccessToken({
        data: {},
        headers: {
          areaId: ''
        },
        responseType: '',
        success: successCallback
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js